import { forwardRef, useState, useEffect } from 'react';
import DirectInput from '../../../../components/directInput/DirectInput';
import DropdownReg from '../../../../components/dropdownReg/DropdownReg';
import MultiSelect from '../../../../components/multiselect/multiselect';
import { fetchTypesData } from './fetchTypes/FetchTypes';
import './quickView.css';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';
import Autocomplete from '../../../../components/reusable-ui-components/autoCompleteSearch/Autocomplete';
import { fetchDropdowns } from '../../../supDropdown/dropdownFun/dropdownCRUD';

const QuickView = forwardRef(({ packData, setPackData }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const diffDrop = ['Easy', 'Medium', 'Difficulty'];
    const foodDrop = ['Veg', 'Non-veg', 'Veg & Non-veg'];
    const [typeSel, setTypeSel] = useState('trip');
    const [typesData, setTypesData] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDropdowns(setDropdownData, setLoading, 0, 10, 'trip', 'dropdown', 'active');
    }, []);

    const baseCitiesData = dropdownData.find((item) => item.heading === 'Base Cities')?.dropdown;
    useEffect(() => {
        fetchTypesData(typeSel, 'Types', setTypesData);
    }, [typeSel]);

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Quick View</h2>
            <div className='orgPackUpSecDiv'>
                {/* <MultiSelect
                    label='Type / Category'
                    helperText='*Can select multiple types'
                    name='type'
                    value={packData.quickView?.type || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setPackData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                type: val
                            }
                        }));
                    }}
                    error={highlightField === 'type'}
                /> */}
                <DirectInput
                    label='Where'
                    name='where'
                    value={packData.quickView?.where}
                    type='text'
                    placeholder='Destination district. Ex - Chikamagluru'
                    setFormData={setPackData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'where'}
                />
                <DropdownReg
                    label='Food'
                    name={'food'}
                    options={foodDrop}
                    value={packData.quickView?.food}
                    req={true}
                    setFormData={setPackData}
                    nest='quickView'
                    error={highlightField === 'food'}
                />
                <div className='dropRegDiv'>
                    <label className={'dropRegLabel'}>Base Cities</label>
                    <Autocomplete
                        dropdownData={baseCitiesData || []}
                        selectedData={packData?.quickView?.baseCities || []}
                        onChange={(updatedArray) => {
                            setPackData((prev) => ({
                                ...prev,
                                quickView: {
                                    ...prev.quickView,
                                    baseCities: updatedArray
                                }
                            }));
                        }}
                        multiSelect={false}
                        placeholder={'Search base cities'}
                    />
                </div>
            </div>
        </div>
    );
});

export default QuickView;
